import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import DatePicker from 'react-datepicker';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

import styles from './HeaderAnalytics.module.scss';

const HeaderAnalytics = props => {
  const {
    title,
    element1_title,
    element1_value,
    element2_title,
    element2_value,
    element3_title,
    element3_value,
    campaignFilter,
    setCampaignFilter,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    refreshData,
  } = props;

  return (
    <React.Fragment>
      <Paper className={styles.paper} elevation={0}>
        <Grid container>
          <Grid item xs={12}>
            <Typography className={styles.subtitle} variant="subtitle1" gutterBottom>
              {title}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.datePickerContainer}>
              Start date:
              <DatePicker
                popperClassName={styles.calendar}
                className={styles.dateFilter}
                placeholderText="Click to select a date"
                selected={dateFrom}
                onChange={date => setDateFrom(date)}
                onBlur={() => refreshData()}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="MMMM d, yyyy h:mm aa"
                disabledKeyboardNavigation
              />
            </div>
            <div className={styles.datePickerContainer}>
              End date:
              <DatePicker
                popperClassName={styles.calendar}
                className={styles.dateFilter}
                placeholderText="Click to select a date"
                selected={dateTo}
                onChange={date => setDateTo(date)}
                onBlur={() => refreshData()}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                timeCaption="time"
                dateFormat="MMMM d, yyyy h:mm aa"
                disabledKeyboardNavigation
              />
            </div>
          </Grid>

          {campaignFilter ? (
            <Grid item xs={3}>
              <div className={styles.element_title}>{'Select Campaign:'}</div>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={campaignFilter === 'all' ? true : false}
                      onChange={() => {
                        setCampaignFilter('all');
                        refreshData();
                      }}
                    />
                  }
                  label="All"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={campaignFilter === 'points' ? true : false}
                      onChange={() => {
                        setCampaignFilter('points');
                        refreshData();
                      }}
                    />
                  }
                  label="Points"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={campaignFilter === 'day1' ? true : false}
                      onChange={() => {
                        setCampaignFilter('day1');
                        refreshData();
                      }}
                    />
                  }
                  label="Day 1"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={campaignFilter === 'day2' ? true : false}
                      onChange={() => {
                        setCampaignFilter('day2');
                        refreshData();
                      }}
                    />
                  }
                  label="Day 2"
                />
              </div>
            </Grid>
          ) : (
            ''
          )}
          <Grid item xs={3}>
            <div className={styles.element1_value}>{element1_value}</div>
            <div className={styles.element_title}>{element1_title}</div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.element2_value}>{element2_value}</div>
            <div className={styles.element_title}>{element2_title}</div>
          </Grid>
          <Grid item xs={3}>
            <div className={styles.element3_value}>{element3_value}</div>
            <div className={styles.element_title}>{element3_title}</div>
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};

export default HeaderAnalytics;
